export default function ArticleCardSkeleton() {
  return (
    <div className="bg-white dark:bg-neutral-800 rounded-lg shadow-xs border border-neutral-200 dark:border-neutral-700 overflow-hidden animate-pulse">
      {/* Image placeholder */}
      <div className="w-full h-48 bg-neutral-200 dark:bg-neutral-700"></div>

      {/* Content */}
      <div className="p-4 space-y-3">
        {/* Title */}
        <div className="space-y-2">
          <div className="h-4 bg-neutral-200 dark:bg-neutral-700 rounded-sm w-3/4"></div>
          <div className="h-4 bg-neutral-200 dark:bg-neutral-700 rounded-sm w-1/2"></div>
        </div>

        {/* Summary */}
        <div className="space-y-2">
          <div className="h-3 bg-neutral-200 dark:bg-neutral-700 rounded-sm w-full"></div>
          <div className="h-3 bg-neutral-200 dark:bg-neutral-700 rounded-sm w-4/5"></div>
          <div className="h-3 bg-neutral-200 dark:bg-neutral-700 rounded-sm w-3/5"></div>
        </div>

        {/* Footer */}
        <div className="flex justify-between items-center pt-2">
          <div className="h-3 bg-neutral-200 dark:bg-neutral-700 rounded-sm w-20"></div>
          <div className="h-3 bg-neutral-200 dark:bg-neutral-700 rounded-sm w-16"></div>
        </div>
      </div>
    </div>
  );
}
